import Api from "../../../../service";
import { SET_ERROR, SET_NAVIGATION, getKey } from "./constants";

const setNavigation = (data, key) => ({
  type: SET_NAVIGATION,
  data,
  key,
});

const setError = (data, key) => ({
  type: SET_ERROR,
  data,
  key,
});

export const getNavigation = (data) => (dispatch) =>
  Api.navigation
    .getNavigation(data)
    .then((response) => {
      dispatch(setNavigation(response, getKey(data)));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error, getKey(data)));
    });
